export default {
  fontFamily: ['NouvelR', 'Helvetica', 'Arial', 'sans-serif'].join(','),
  h1: {
    fontSize: '1.5rem', // 24px
    fontWeight: 600,
    lineHeight: 1.25,
  },
  h2: {
    fontSize: '1.375rem', // 22px
    fontWeight: 700,
    lineHeight: 1.2,
  },
  h3: {
    fontSize: '1.25rem', // 20px
    fontWeight: 700,
    lineHeight: 1.5,
  },
  h4: {
    fontSize: '1.125rem', // 18px
    fontWeight: 700,
    lineHeight: 1.5,
  },
  h5: {
    fontSize: '1.125rem', // 18px
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body1: {
    fontSize: '1rem', // 16px
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body2: {
    fontSize: '.875rem', // 14px
    fontWeight: 400,
    lineHeight: 1.57,
  },
  button: {
    fontSize: '1rem', // 16px
    fontWeight: 700,
    lineHeight: 1.5,
  },
  caption: {
    fontSize: '.75rem', // 12px;
    fontWeight: 400,
    lineHeight: 1.33,
  },
}
